module.exports = __webpack_public_path__ + "img/10.f6cffee3.png";